// Leaflet
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import companyData from "../../companyData";

const Map = () => {
  return (
    <MapContainer
      style={{ height: "25rem", borderRadius: "5px" }}
      center={companyData.mapcordinates}
      zoom={13}
      scrollWheelZoom={false}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Marker position={companyData.mapcordinates}>
        <Popup>{companyData.name}</Popup>
      </Marker>
    </MapContainer>
  );
};

export default Map;
